module.exports = __webpack_public_path__ + "img/pic_shiny1.66f6c563.png";